module.exports = __webpack_public_path__ + "img/GH-kyujin-top-h-pa-1.a7133748.webp";